import React, { useContext, useEffect, useState } from 'react';
import { WithDataFetcher } from '../../Data/WithDataFetcher';
import { FormContext } from '../FormEngine';
import { getHealthWellFunds } from '../SpecialRules/HealthWellSpecialRules';
import SelectInput from './SelectInput';

//takes an onChange prop and calls it with (dataKey, newValue)
const HealthWellFundSelectInput = props => {
    const { onChange } = props;
    const { getThenResolver } = props;
    const [funds, setFunds] = useState(null);

    const ctx = useContext(FormContext);

    useEffect(() => {
        async function loadFunds() {
            const funds = await getHealthWellFunds(getThenResolver, ctx.meta.assistanceProgramId);

            if (funds && funds.length > 0) {
                // find funds based on selected AssistanceService from application wizard
                // filter based on insurance selection
                var filteredFunds = funds
                    .find(f => f.assistanceServiceId === ctx.meta.assistanceServices[0].id).funds
                    .filter(f => {
                        const ins = ctx.formData['Insurance Primary Type'];

                        return ins
                            ? f.insuranceClassName === ins
                            : true
                    })
                    .flatMap(f => f.funds);

                var fundOptions = [...new Set(filteredFunds)]
                    .sort((a, b) => a < b ? -1 : 1)
                    .map((fund, idx) => (
                        { key: `${fund}/${idx}`, value: fund, text: fund }
                    ));

                setFunds(fundOptions);
            }
        };

        loadFunds();
    
    }, []);

    if (!funds || funds.length === 0) { return null; }

    const myProps = {
        ...props,
        def: {
            ...props.def,
            options: funds.map(f => f.text),
            values: funds.map(f => f.value)
        },
        onChange: (dataKey, value) => {
            ctx.specialRuleChangeData('HealthWell Fund Medication', '');
            onChange(dataKey, value);
        },
        name: 'healthwellfundselectinput_de'
    }

    return <SelectInput {...myProps} />
}

export default WithDataFetcher(HealthWellFundSelectInput);
